import { render, staticRenderFns } from "./div-scroll.vue?vue&type=template&id=78e054c0&"
import script from "./div-scroll.vue?vue&type=script&lang=ts&"
export * from "./div-scroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports